import type React from 'react'
import { Form } from 'react-aria-components'

import { css } from '@portal/styled-system/css'

import { useI18n } from '@/shared/lib/i18n'
import { CancelButton, Modal, type ModalProps, ProceedButton } from '@/shared/ui'
import { EmailInput } from '@/shared/ui/input-v2/email'

export type PasswordForgotDialogProps = ModalProps & {
    onClick: (params: { email: string }) => void
    nonInteractive?: boolean
}

export function PasswordForgotDialog(props: PasswordForgotDialogProps) {
    const { onClick, nonInteractive, ...modalProps } = props

    const { i18n } = useI18n()

    const handleFormSubmit = (evt: React.SyntheticEvent<HTMLFormElement>) => {
        evt.preventDefault()

        // @ts-expect-error
        const email = evt.target['email'].value

        onClick({ email })
    }

    return (
        <Modal {...modalProps}>
            <Modal.CloseButton onClose={modalProps.onClose} />
            <Modal.Header styles={css.raw({ backgroundColor: 'info', px: '5' })} icon="fa-solid fa-rocket-launch">
                {i18n.ACCOUNT_PASSWORD_RESET}
            </Modal.Header>
            <Modal.Body>
                <Form method="post" onSubmit={handleFormSubmit}>
                    <div
                        className={css({ marginBottom: '4' })}
                        dangerouslySetInnerHTML={{ __html: i18n.TEXT_EMAIL_TO_RESET_PASSWORD }}
                    />
                    <EmailInput placeholder={i18n.PLACEHOLDER_YOUR_EMAIL} isDisabled={nonInteractive} />
                    <Modal.Buttons styles={css.raw({ padding: '0', paddingTop: '3' })}>
                        <CancelButton onPress={modalProps.onClose} styles={css.raw({ width: 'auto' })} />
                        <ProceedButton type="submit" isDisabled={nonInteractive}>
                            {i18n.BUTTON_RESET_PASSWORD}
                        </ProceedButton>
                    </Modal.Buttons>
                </Form>
            </Modal.Body>
        </Modal>
    )
}
